import { useContext, useEffect, useState } from "react";
import Button from "../../../atoms/button";
import { cashnator, cashnatorFloat, decashnator, isNumeric } from "../../../utils/functions";
import { getCalculatedData } from "../../functions";
import ToastContext from "../../../../context/toastProvider";
import Loading from "../../../atoms/loading";
import { Field, inputClasses } from "../../../atoms/formField";

const CheckoutStep = ({ user, productData, deliveryData, setStep, setProductData, setDeliveryData }) => {

    const { badToast } = useContext(ToastContext);

    const [loading, setLoading] = useState(false);
    const [insurance, setInsurance] = useState(cashnator(productData?.insurance) || cashnatorFloat(productData?.declaredValue * 3 / 10000) || "R$0,00");
    const [tipoFrete, setTipoFrete] = useState(deliveryData?.shipping?.service || productData?.shippingService || "");
    const [valorFrete, setValorFrete] = useState(cashnatorFloat(deliveryData?.shipping?.price || "") || cashnatorFloat(productData?.shipping));
    const [finalPrice, setFinalPrice] = useState(cashnator(productData?.finalPrice) || "R$0,00");
    const [deadline, setDeadline] = useState(productData?.deadline || "");
    const [enableChanges, setEnableChanges] = useState(false);
    const [recalculate, setRecalculate] = useState(false);

    useEffect(() => {
        doGetCalculatedData();
        // eslint-disable-next-line
    }, []);

    const doGetCalculatedData = async () => {
        setLoading(true);
        const data = await getCalculatedData(user?.token, productData?.gradingType, productData?.numberOfCards, productData?.priority, decashnator(insurance), deliveryData?.store, deliveryData?.delivery, deliveryData?.shipping?.price, productData?.autographEvaluation);
        if (data?.type !== "success") {
            badToast("Erro no cálculo do preço e prazo");
            setLoading(false);
            return null;
        }
        if (!productData?.finalPrice || recalculate) {
            setFinalPrice(cashnator(data?.data?.finalPrice));
        }
        if (!productData?.deadline || recalculate) {
            setDeadline(data?.data?.deadline);
        }
        setRecalculate(false);
        setLoading(false);
    }

    const doRecalculate = async () => {
        setLoading(true);
        const data = await getCalculatedData(user?.token, productData?.gradingType, productData?.numberOfCards, productData?.priority, decashnator(insurance), deliveryData?.store, deliveryData?.delivery, deliveryData?.shipping?.price, productData?.autographEvaluation);
        if (data?.type !== "success") {
            badToast("Erro no cálculo do preço e prazo");
            setLoading(false);
            return null;
        }
        setFinalPrice(cashnator(data?.data?.finalPrice));
        setDeadline(data?.data?.deadline);
        setRecalculate(false);
        setLoading(false);
    }

    const goBack = () => {
        if (deliveryData?.delivery === "correios") {
            setStep(3);
        }
        if (deliveryData?.delivery === "presencial") {
            setStep(2);
        }
    }

    const handleNext = () => {
        setProductData(p => { return { ...p, finalPrice: decashnator(finalPrice), deadline, insurance: decashnator(insurance), shippingService: tipoFrete, shipping: parseInt(decashnator(valorFrete)) / 100 } });
        setDeliveryData(d => { return { ...d, shipping: { service: tipoFrete, price: parseInt(decashnator(valorFrete)) / 100 } } })
        setStep(7);
    }

    const handleValorFrete = (value) => {
        if (!value) {
            setValorFrete("R$0,00");
            return null;
        }
        const newValue = decashnator(value);
        if (isNumeric(newValue)) {
            setValorFrete(cashnator(newValue));
        }
    }

    const handleInsurance = (value) => {
        if (!value) {
            setInsurance("R$0,00");
            return null;
        }
        const newValue = decashnator(value);
        if (isNumeric(newValue)) {
            setInsurance(cashnator(newValue));
        }
    }

    const handleFinalPrice = (value) => {
        if (!value) {
            setFinalPrice("R$0,00");
            return null;
        }
        const newValue = decashnator(value);
        if (isNumeric(newValue)) {
            setFinalPrice(cashnator(newValue));
        }
    }

    const handleDeadline = (value) => {
        if (!value) {
            setDeadline("");
            return null;
        }
        if (isNumeric(value)) {
            setDeadline(value);
        }
    }

    return (
        <div className="relative">
            {/* Destaques calculados */}
            <div className="mb-4 grid grid-cols-2 gap-3">
                <div className="rounded-lg border border-primary bg-mgs-elevated px-4 py-3 text-left">
                    <p className="text-xs text-laranjinha/60">Valor final</p>
                    <p className="text-2xl font-bold text-laranjinha">{finalPrice}</p>
                </div>
                <div className="rounded-lg border border-primary/40 bg-mgs-surface/60 px-4 py-3 text-left">
                    <p className="text-xs text-laranjinha/60">Prazo</p>
                    <p className="text-2xl font-bold text-laranjinha">{deadline || "—"} <span className="text-sm font-normal text-laranjinha/60">dias úteis</span></p>
                </div>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <Field label="Taxa de manuseio" hint="Sugerida: 3% do valor declarado">
                    <input type="text" inputMode="numeric" value={insurance} onChange={e => handleInsurance(e.target.value)} className={inputClasses} disabled={!enableChanges} />
                </Field>
                <Field label="Prazo (dias úteis)">
                    <input type="text" inputMode="numeric" value={deadline} onChange={e => handleDeadline(e.target.value)} className={inputClasses} disabled={!enableChanges} />
                </Field>
                {
                    deliveryData?.delivery === "correios" ? (
                        <>
                            <Field label="Tipo de frete">
                                <select disabled={!enableChanges} value={tipoFrete} className={inputClasses} onChange={e => setTipoFrete(e.target.value)}>
                                    <option value="MINI">MINI</option>
                                    <option value="PAC">PAC</option>
                                    <option value="SEDEX">SEDEX</option>
                                </select>
                            </Field>
                            <Field label="Valor do frete">
                                <input type="text" inputMode="numeric" value={valorFrete} onChange={e => handleValorFrete(e.target.value)} className={inputClasses} disabled={!enableChanges} />
                            </Field>
                        </>
                    ) : null
                }
                <Field label="Valor final" className="sm:col-span-2">
                    <input type="text" inputMode="numeric" value={finalPrice} onChange={e => handleFinalPrice(e.target.value)} className={inputClasses} disabled={!enableChanges} />
                </Field>
            </div>

            <div className="mt-3 flex flex-wrap items-center justify-between gap-2">
                <label className="flex items-center gap-2 text-sm text-laranjinha/70">
                    <input
                        type="checkbox"
                        className="h-4 w-4 accent-[#d59106]"
                        checked={enableChanges}
                        onChange={e => setEnableChanges(e.target.checked)}
                    />
                    Editar valores manualmente
                </label>
                <button
                    type="button"
                    onClick={doRecalculate}
                    className="rounded-lg border border-primary/40 px-3 py-1 text-sm text-laranjinha hover:border-primary"
                >
                    ↻ Recalcular
                </button>
            </div>
            {
                enableChanges ?
                    <p className="mt-1 text-left text-xs text-primary">Edição manual ativa — os valores digitados substituem o cálculo automático.</p>
                    : null
            }

            <div className="m-auto mt-5 flex w-fit gap-3">
                <Button click={goBack} classes="bg-purple-400 hover:bg-purple-300 px-4">← Voltar</Button>
                <Button click={handleNext} classes="bg-green-400 hover:bg-green-300 px-6">Revisar pedido →</Button>
            </div>
            {/* LOADING OVERLAY */}
            {
                loading ?
                    <div className="absolute top-0 left-0 w-full h-full bg-[#000000dd] flex justify-center items-center">
                        <Loading />
                    </div>
                    : null
            }
        </div>
    )
}

export default CheckoutStep;
